<template>
  <div class="depot">
    <!--导航栏-->
    <header-nav></header-nav>

    <div class="user-center">
      <div class="border-card-main">

        <el-table
            v-loading="loadingData"
            :data="tableData"
            height="600px"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            border
            style="width: 100%">
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="仓储名">
            <template slot-scope="scope">
              <span>{{ scope.row.depot_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="仓储地址">
            <template slot-scope="scope">
              <span>{{ scope.row.pro + scope.row.city + scope.row.dis + scope.row.address}}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="page-box">
          <el-pagination
              :page-size="param.limit"
              :page-sizes="[20, 50, 100, 200, 300, 400]"
              :total="total"
              layout="prev, pager, next,total,sizes,jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
        </div>
      </div>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>

import headerNav from "@/components/headerNav/index"
import footerBox from "@/components/footerBox/index"
import {apiDepotGetAll} from "@/api/api"
export default {
  name: "depot",
  components: {headerNav, footerBox},
  data(){
    return{
      total: 0,
      param: {
        limit: 20,
        page: 1
      },
      loadingData: false,
      tableData: [],
    }
  },
  mounted(){
    this.loadData();
  },
  methods:{
    handleSizeChange(val){
      this.param.limit = val;
      this.loadData();
    },
    handleCurrentChange(val){
      this.param.page = val;
      this.loadData();
    },
    loadData(){
      apiDepotGetAll(this.param).then(res => {
        if(res.code === 1){
          this.tableData = res.data.rows;
          this.total = res.data.total;
        }
      })
    },
  }

}
</script>

<style scoped lang="scss">
.depot {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;

    .border-card-main {
      min-height: calc(100vh - 220px);
      background-color: #ffffff;
      padding: 20px;

    }

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/depot/index.vue